import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-watch",
  "use": "icon-watch-usage",
  "viewBox": "0 0 17 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 12\" id=\"icon-watch\"><path d=\"M12 3.8l4.2-3c.2-.2.5-.1.7.1.1.1.1.2.1.3v9.2c0 .3-.2.5-.5.5-.1 0-.2 0-.2-.1L12 8.4V11c0 .6-.4 1-1 1H1c-.6 0-1-.4-1-1V1c0-.6.4-1 1-1h10c.6 0 1 .4 1 1v2.8z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol